import Button from "#React/ui/Button/Button"
import { cn } from "#Utils/cn"

const EmptyState = ({
  icon = "search",
  title = "No data found",
  description = "We haven't found any data.",
  actionTitle,
  actionFunction,
  actionLink,
  actionTo,
  actionLinkOptions,
  actionSearch,
  actionLinkExternal,
  className = "",
}) => (
  <div
    className={cn(
      "flex flex-col w-full h-full justify-center items-center px-5 max-w-md mx-auto text-center",
      className,
    )}
  >
    {icon && <i className={`text-2xl text-content-muted fa fa-${icon} my-4`} />}
    <h2 className="c-heading c-heading--base">{title}</h2>
    {/* Since the children can be JSX, having div inside p can cause warnings. Using div here. */}
    <div className="text-content-secondary">{description}</div>
    {actionTitle && actionFunction && (
      <Button className="my-4 c-button--white" onClick={actionFunction}>
        {actionTitle}
      </Button>
    )}
    {actionTitle && (actionLink || actionTo || actionLinkOptions) && (
      <Button
        className="my-4 c-button--white"
        href={actionLink}
        to={actionTo}
        search={actionSearch}
        {...actionLinkOptions}
        type="link"
      >
        {actionTitle}
      </Button>
    )}
    {/* Button#link is optimized for client-side routing, so let's use a dedicated anchor for external links */}
    {actionTitle && actionLinkExternal && (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="my-4 c-button c-button--white c-button--sm"
        href={actionLinkExternal}
      >
        {actionTitle}
      </a>
    )}
  </div>
)

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.node,
  actionTitle: PropTypes.string,
  actionFunction: PropTypes.func,
  actionLink: PropTypes.string,
  actionTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  actionLinkOptions: PropTypes.object,
  actionSearch: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  actionLinkExternal: PropTypes.string,
  className: PropTypes.string,
}

export default EmptyState
